const data = {
    PHONE: '15302709122',
    PHONE_DISPLAY: '(530) 270-9122'
}
export default data